<div class="error-container">
  <img src="/src/assets/error-illustration.svg" alt="" />
  <h2>{{ error.name }}</h2>
  <p>{{ error.message }}</p>
</div>
